export default "__VITE_ASSET__De1LpHV2__"